import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { mapShippingMethods } from '../../../../mappers/view/shipping-methods.js';
import '../../../../mappers/errors-mapping.js';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import { ShippingMethodInfo } from '../../../modules/ShippingMethods/components/ShippingMethodInfo.js';
import { useShippingMethodsList } from '../../../modules/ShippingMethods/hooks/use-shipping-methods-list.js';

const useGroupedShippingMethods = (selectedShippingMethod, onShippingMethodsLoadCompleted)=>{
    const { locale  } = useIntl();
    const { shippingMethodsLogos  } = useCheckoutSettings();
    const { shippingMethodList , isLoading , error  } = useShippingMethodsList(onShippingMethodsLoadCompleted);
    const homeDeliveryShippingMethodGroups = React.useMemo(()=>{
        const sharedGroup = [
            ShippingMethod.Delivery,
            ShippingMethod.DeliveryExpress,
            ShippingMethod.DeliveryPremium, 
        ];
        return Object.fromEntries(sharedGroup.map((method)=>[
                method,
                sharedGroup
            ]
        ));
    }, []);
    const shippingMethodInfo = ({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(ShippingMethodInfo, {
            price: price,
            logo: logo,
            isFree: isFree
        })
    ;
    const items = mapShippingMethods({
        logos: shippingMethodsLogos,
        locale,
        shippingMethodList,
        shippingMethodInfo
    });
    const allowedKeys = React.useMemo(()=>{
        return (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? homeDeliveryShippingMethodGroups[selectedShippingMethod.method] || [
            selectedShippingMethod.method, 
        ] : [];
    }, [
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method,
        homeDeliveryShippingMethodGroups
    ]);
    return {
        groupedShippingMethods: React.useMemo(()=>items.filter((item)=>allowedKeys.includes(item.value)
            )
        , [
            allowedKeys,
            items
        ]),
        error,
        isLoading
    };
};

export { useGroupedShippingMethods };
//# sourceMappingURL=use-grouped-shipping-methods.js.map
